import { post } from "../axios";

export default {
  // 图片域名
  memberCardList() {
    return post("StoreAdmin/Common/getOssPath");
  },

 
};



// WEBPACK FOOTER //
// ./src/Interface/api/common.js